<template>
  <div class="w-full">
    <Head title="Panel — Centrum Medyczne CODE" />
    <div class="mb-8">
      <h1 class="mb-2 text-3xl font-bold text-gray-900">Administracja strony Centrum Medycznego CODE</h1>
      <p class="text-gray-600">
        Zarządzaj treścią i ustawieniami strony Centrum Medycznego CODE.
      </p>
    </div>

    <div class="rounded-lg bg-white shadow-sm">
      <div class="px-6 py-5">
        <p class="text-gray-600">
          To jest panel administracyjny do zarządzania stroną statyczną Centrum Medycznego CODE.
        </p>
        <div class="mt-4">
          <Link
            href="/"
            class="text-sm font-medium text-indigo-600 hover:text-indigo-500"
            target="_blank"
          >
            Zobacz stronę Centrum Medycznego CODE →
          </Link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import AdminCodeMedicalCenterLayout from '@/Layouts/AdminCodeMedicalCenter.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: AdminCodeMedicalCenterLayout,
};
</script>
